import type { RecordView } from '@kit/sync/types/record-view';
import { useRecords } from '@/entities/shared/record/use-records';
import type { Item } from '../schemas/item';

export function useItems(): RecordView<Item>[] | undefined {
  return useRecords<Item>('items');
}
